module.exports = __webpack_public_path__ + "img/156.03b1e305.jpg";